const App = {
    loadForm($form, status, delay = 0) {
        const $wrapper = $form.parent('div');
        if (status === 'start') {
            $form.hide().find('.js_input_wrapper').hide();
            $wrapper.append('<div class="loader_form js__loader_form"><span class="loader_element"></span></div>');
            $form.find('.js_form_btn').prop('disabled', true);
        } else if (status === 'stop') {
            $form.show();
            $wrapper.find('.js__loader_form').remove();
            $form.find('.js_form_btn').prop('disabled', false);
            setTimeout(() => $form.find('.js_input_wrapper').show(), delay);
        }
    },

    isValidEmail(email) {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    },

    isValidPhone($input) {
        if (!mask_phone) return true;
        const phoneNumber = $input.val().replace(/\D/g, '');
        return phoneNumber.length === 12;
    },

    getErrorMessage(inputName, lang) {
        const messages = {
            phone: {
                ru: 'Пожалуйста, введите корректный номер телефона (12 цифр)',
                uk: 'Будь ласка, введіть коректний номер телефону (12 цифр)',
                bg: 'Моля, въведете валиден телефонен номер (12 цифри)',
                en: 'Please enter a valid phone number (12 digits)',
                pl: 'Proszę wprowadzić poprawny numer telefonu (12 cyfr)'
            },
            email: {
                ru: 'Пожалуйста, введите корректный email',
                uk: 'Будь ласка, введіть коректний email',
                bg: 'Моля, въведете валиден имейл',
                en: 'Please enter a valid email',
                pl: 'Proszę wprowadzić poprawny email'
            },
            required: {
                ru: 'Это поле обязательно для заполнения',
                uk: 'Це поле обов’язкове для заповнення',
                bg: 'Това поле е задължително',
                en: 'This field is required',
                pl: 'To pole jest wymagane'
            }
        };
        return messages[inputName] ? messages[inputName][lang] : messages.required[lang];
    },

    validateForm($form) {
        let isValid = true;
        const lang = window.lang || 'en';

        $form.find('input[required]').each((_, input) => {
            const $input = $(input);
            const value = $input.val().trim();
            const $wrapper = $input.closest('.js_input_wrapper');
            const inputName = $input.attr('name');

            $wrapper.removeClass('forms__error error_num_intut error_email_intut');
            $wrapper.find('.input__error').remove();
            if (!value) {
                isValid = false;
                $wrapper.addClass('forms__error').append(`<span class="input__error">${this.getErrorMessage('required', lang)}</span>`);
            } else if (inputName === 'phone' && !this.isValidPhone($input)) {
                isValid = false;
                $wrapper.addClass('forms__error error_num_intut').append(`<span class="input__error">${this.getErrorMessage('phone', lang)}</span>`);
            } else if (inputName === 'email' && !this.isValidEmail(value)) {
                isValid = false;
                $wrapper.addClass('forms__error error_email_intut').append(`<span class="input__error">${this.getErrorMessage('email', lang)}</span>`);
            }
        });

        // Bot protection checks
        const honeypot = $form.find('input[name="honeypot"]').val();
        const timestamp = $form.find('input[name="timestamp"]').val();
        const currentTime = Date.now();
        if (honeypot || !timestamp || (currentTime - timestamp > 30000)) {
            isValid = false;
        }

        return isValid;
    },

    getGtmData($element) {
        return $element.hasClass('js__gtm_btn')
            ? { itemList: $element.attr('data-gtm_item_list'), item: $element.attr('data-gtm_item') }
            : { itemList: $element.closest('.js_good_tile').attr('data-gtm_item_list'), item: $element.closest('.js_good_tile').attr('data-gtm_item') };
    },

    pushGtmEvent(event, data, gtmData = {}) {
        if (!gtmActive) return;
        $.post(routes.getGTMLocal, { id: data.id }, (res) => {
            if (res.status === 'ok') {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event,
                    label: 'main',
                    ecommerce: {
                        ...(event === 'purchase' ? {
                            transaction_id: gtmData.transaction_id,
                            affiliation: gtmData.affiliation,
                            value: gtmData.value,
                            currency: gtmData.currency
                        } : {}),
                        items: [{
                            item_name: res.data.name,
                            item_id: String(res.data.id),
                            price: Number(res.data.price_gtm),
                            item_brand: res.data.item_brand,
                            item_category: res.data.cat1 || null,
                            item_category2: res.data.cat2 || null,
                            item_variant: res.data.gtm_remains,
                            item_list_name: gtmData.itemList,
                            index: Number(gtmData.item),
                            quantity: data.quantity || 1
                        }]
                    }
                });
            }
        });
    },

    handleProductButtonClick($button) {
        const data = {
            id: $button.attr('data-id'),
            name: $button.attr('data-name'),
            modal: $button.attr('data-modal'),
            href: $button.attr('data-href'),
            value: $button.attr('data-value')
        };
        const $modal = $(`#${data.modal}`);

        if (data.value) $modal.find('.js_input_value').val(data.value);
        $modal.find('.js_input_id').val(data.id).end()
            .find('.js_modal_name').text(data.name);
        if (data.href) $modal.find('.js_input_url').val(data.href);
        $modal.addClass('js_active');

        if (['modal_one_click', 'modal_price_req', 'modal_good_req'].includes(data.modal)) {
            const gtmData = this.getGtmData($button);
            $modal.find('.js_form_btn').attr({
                'data-gtm_item_list': gtmData.itemList,
                'data-gtm_item': gtmData.item
            });
        }
    },

    handleAddToCart($button) {
        const gtmData = this.getGtmData($button);
        $.post('add-to-cart', {
            good_id: $button.attr('data-id'),
            value: $button.attr('data-value'),
            valueName: $button.attr('data-title'),
            lang
        }, (res) => {
            if (res.status === 'ok') {
                $('#cart_modal_content').empty().append(res.html);
                $('#modal_add_good_to_cart').addClass('js_active')
                    .find('.lazyload').attr('src', $('#modal_add_good_to_cart .lazyload').attr('data-src'));
                $button.removeClass('to_cart').addClass('in_cart');
                $('.block-btn-wrap-good button[data-text-result]').removeClass('to_cart').addClass('in_cart');
                this.loadTopCart();

                if (gtmActive && !JSON.parse(localStorage.getItem(res.return_data.good_id))) {
                    $.post(routes.getGTMLocal, { id: $button.attr('data-id') }, (gtmRes) => {
                        if (gtmRes.status === 'ok') {
                            const itemData = {
                                item_name: gtmRes.data.name,
                                item_id: String(gtmRes.data.id),
                                price: Number(gtmRes.data.price_gtm),
                                item_brand: gtmRes.data.item_brand,
                                item_category: gtmRes.data.cat1 || null,
                                item_category2: gtmRes.data.cat2 || null,
                                item_variant: gtmRes.data.gtm_remains,
                                item_list_name: gtmData.itemList,
                                index: Number(gtmData.item),
                                quantity: 1
                            };
                            const gtmItems = [itemData, { quantity: 1 }];
                            this.pushGtmEvent('add_to_cart', { id: $button.attr('data-id'), quantity: 1 }, gtmData);
                            localStorage.setItem(res.return_data.good_id, JSON.stringify(gtmItems));
                        }
                    });
                }

                if (is_facebook_pixel && parseInt(res.return_data.price) > 0) {
                    fbq('track', 'AddToCart', {
                        value: res.return_data.price,
                        currency: 'UAH',
                        content_ids: res.return_data.good_id,
                        content_type: 'product'
                    });
                }
            }
        });
    },

    loadTopCart() {
        $.post('load-top-cart', { lang }, (res) => {
            if (res.status === 'ok') $('.js_header_cart').empty().append(res.html);
        });
    },

    loadMainCart() {
        $.post('load-main-cart', { lang }, (res) => {
            if (res.status === 'ok') {
                $('.js_main_cart').empty().append(res.html);
                goodsDeclination();
            }
        });
    },

    handleQuantityChange($button, direction) {
        const $input = $button.parent().find('input');
        const productId = $input.attr('data-id');
        let currentValue = parseInt($input.val());
        const change = direction === 'down' ? -1 : 1;
        const newValue = Math.max(direction === 'down' ? currentValue - 1 : currentValue + 1, 1);
        $(`.js_amount_count[data-id="${productId}"]`).val(newValue).change();

        $.post('update-cart', { id: productId, count: change, lang }, (res) => {
            if (res.status === 'ok') {
                $('.js_modal_good_subtotal').html(res.new_sum);
                $(`.js_cart_good_subtotal[data-id="${productId}"]`).html(res.new_sum);
                this.loadTopCart();

                let goodObject = JSON.parse(localStorage.getItem(productId)) || [{}, { quantity: 1 }];
                goodObject[1].quantity = Number(newValue);
                localStorage.setItem(productId, JSON.stringify(goodObject));

                if (gtmActive && change === 1) { // Отправляем событие только при увеличении
                    const itemData = goodObject[0] || {};
                    this.pushGtmEvent('add_to_cart', {
                        id: productId,
                        quantity: 1 // Добавляем только 1 единицу
                    }, {
                        itemList: itemData.item_list_name,
                        item: itemData.index
                    });
                }

                if ($('.js_main_cart').length) this.loadMainCart();
            }
        });
    },

    handleDeleteFromCart($button) {
        const productId = $button.attr('data-id');
        $.post('delete-cart', { id: productId, lang }, (res) => {
            if (res.status === 'ok') {
                $button.closest('.cart_page_item').remove();
                this.loadTopCart();
                this.loadMainCart();
                localStorage.removeItem(productId);
                if (!$('.cart_page_item').length) window.location.href = main_market_cat;
            }
        });
    },

    handleGetVariants($button) {
        const gtmData = this.getGtmData($button);
        $.post(routes.getVariant, {
            good_id: $button.attr('data-id'),
            lang,
            type_car: $button.attr('data-modal'),
            gtm_index: gtmData.item,
            gtm_ltem_list: gtmData.itemList
        }, (res) => {
            if (res.status === 'ok') {
                const $modalHeader = $('#modal_good_size').find('.modal__header');
                $modalHeader.text(`${$modalHeader.attr('data-text')} ${res.title_variant}`);
                $('#modal_good_size').find('.modal__body').empty().append(res.html).end().addClass('js_active');
            }
        });
    },

    handleProductTileHover($tile) {
        const $link = $tile.closest('.good_tile__link');
        $link.attr('href', $tile.attr('data-href'));
        const image = $tile.attr('data-image');
        if (image) $link.find('.good_tile_img').attr('src', image);
    },

    handleWishlistToggle($button) {
        const id = $button.attr('data-id');
        const gtmData = this.getGtmData($button);
        $button.parents('.js_parent_like').addClass('js_show');

        if ($button.hasClass('to_wishlist')) {
            $.post(routes.editWishlist, { id, action: 'add' }, (res) => {
                if (res.status === 'ok') {
                    $button.removeClass('to_wishlist').addClass('in_wishlist');
                    this.updateWishIcon();
                    this.pushGtmEvent('add_to_wishlist', { id }, gtmData);
                }
            });
        } else if ($button.hasClass('in_wishlist')) {
            $.post(routes.editWishlist, { id, action: 'remove' }, (res) => {
                if (res.status === 'ok') {
                    $button.removeClass('in_wishlist').addClass('to_wishlist');
                    $button.parents('.js_parent_like').removeClass('js_show');
                    this.updateWishIcon();
                }
            });
        }
    },

    updateWishIcon() {
        $.post(routes.loadWishIcon, { lang }, (res) => {
            if (res.status === 'ok') $('.js_header_like').empty().append(res.html);
        });
    },

    handleReviewSubmission(form, file = '') {
        if (!this.validateForm($(form))) {
            this.loadForm($(form), 'stop');
            return;
        }

        const data = file ? { data: $(form).serialize(), file, subj: 'review' } : { data: $(form).serialize(), subj: 'review' };
        $.post(routes.postSend, data, () => {
            $(form)[0].reset();
            this.loadForm($(form), 'stop');
            if (is_facebook_pixel) fbq('track', 'feedback');
            if (gtmActive) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({ event: 'feedback' });
            }
            $('.js_add_file').removeClass('js_hide');
            $('.js_list_file_reviews').empty();
            $('.input-file-js').remove();
            setTimeout(() => {
                $('.ajax-loader').addClass('hidden');
                $('#form-reviews').find('.form-input').val('').blur();
                $('.span__error').hide();
                $('.review-form-js').find('.review-form__success').slideDown(300).delay(3000).slideUp(300);
            }, 100);
        });
    },

    handleFileInput(e) {
        e.preventDefault();
        const $form = $(e.currentTarget).closest('.form-reviews');
        const fileCount = $('.js_item_file_reviews').length;
        const number = fileCount === 0 ? 1 : Number($('.js_item_file_reviews').attr('data-number')) + 1;

        if (fileCount < 2) {
            const $sizeError = $('.form__size-error-js');
            const $extensionError = $('.form__extention-err-js');
            const whiteList = [
                'text/plain', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/pdf',
                'application/octet-stream', 'image/jpeg', 'image/png', 'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.spreadsheet'
            ];
            const $input = $(`<input type="file" name="photo_${number}" accept="image/*" class="input-hidden input-file-js"/>`);

            $input.hide().on('change', function () {
                if (this.files.length) {
                    const file = this.files[0];
                    if ((whiteList.includes(file.type) || file.name.includes('.dwg')) && file.size < 12000000) {
                        $sizeError.removeClass('js_show');
                        $extensionError.removeClass('js_show');
                        $form.append($input);
                        $('ul.js_list_file_reviews').append(
                            `<li class="js_item_file_reviews item_file_reviews" data-number="${number}" data-item="photo_${number}">
                                <span class="name">${file.name}</span>
                                <span class="js_item_file_delete item_file_delete"></span>
                            </li>`
                        );
                        if ($('.js_item_file_reviews').length === 2) $('.js_add_file').addClass('js_hide');
                    } else {
                        $sizeError.toggleClass('js_show', file.size > 12000000);
                        $extensionError.toggleClass('js_show', !whiteList.includes(file.type));
                        this.value = '';
                    }
                }
            }).trigger('click');
        } else {
            $(e.currentTarget).addClass('js_hide');
        }
    },

    handleFormSubmission($button) {
        const formId = $button.attr('data-id');
        const $form = $(`.js_form[id="${formId}"]`);
        const gtmData = ['market_order_one_click', 'good_request', 'price_request'].includes(formId)
            ? this.getGtmData($button)
            : {};

        if (!this.validateForm($form)) {
            this.loadForm($form, 'stop');
            return;
        }

        this.loadForm($form, 'start');

        $.post(routes.postSend, {
            _token: $('meta[name="csrf-token"]').attr('content'),
            data: $form.serialize(),
            subj: $form.attr('data-subj'),
            send_type: $form.attr('data-modal'),
            form_id: formId
        }).done((res) => {
            if (res.status === 'ok') {
                $form[0].reset();

                if (res.form_id === 'market_order_one_click' && gtmActive) {
                    this.pushGtmEvent('purchase', {
                        id: $(`#${res.form_id} input[name="good_id"]`).val()
                    }, {
                        ...gtmData,
                        transaction_id: res.order_id,
                        affiliation: 'by_one_click',
                        value: res.return_data?.price,
                        currency: 'UAH'
                    });
                }

                if (['good_request', 'price_request'].includes(res.form_id) && gtmActive) {
                    this.pushGtmEvent(res.form_id, {
                        id: $(`#${res.form_id} input[name="good_id"]`).val()
                    }, gtmData);
                }

                if (res.form_id === 'callback' && is_facebook_pixel) {
                    fbq('track', 'Contact');
                }

                if (is_facebook_pixel && res.form_id === 'market_order_one_click' && res.return_data?.price) {
                    fbq('track', 'Purchase', {
                        value: res.return_data.price,
                        currency: 'UAH',
                        content_ids: res.return_data.good_id,
                        content_type: 'product'
                    });
                }

                if (res.form_id === 'callback' && gtmActive) {
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({ event: 'callback' });
                }

                this.loadForm($form, 'stop', 20000);
                const $success = $(`.form__success[data-success="${res.form_id}"]`);
                $success.removeClass('js_hide');

                $('.input__input').next('.input__placeholder').css({ top: '14px' }).end().removeClass('active_input');
                $('.js_rating_text').addClass('js_hide');

                setTimeout(() => {
                    $success.addClass('js_hide');
                    if (res.send_type === 'modal') {
                        $('.modal.js_active').removeClass('js_active');
                        $('html').css('overflow', '');
                    }
                }, 20000);
            }
        }).fail((xhr, status, error) => {
            let errorMessage = 'Произошла ошибка при отправке формы';
            let statusCode = xhr.status;

            if (xhr.status === 400) {
                try {
                    const errorResponse = JSON.parse(xhr.responseText);
                    errorMessage = errorResponse.message || 'Ошибка валидации формы';
                } catch (e) {
                    errorMessage = 'Ошибка валидации формы';
                }
            } else if (xhr.status === 500) {
                errorMessage = 'Ошибка сервера. Попробуйте позже.';
            }

            this.loadForm($form, 'stop');

            const $error = $(`.form__error[data-error="${formId}"]`);
            if ($error.length) {
                $error.text(errorMessage).removeClass('js_hide');
                setTimeout(() => $error.addClass('js_hide'), 5000);
            } else {
                alert(errorMessage);
            }
        });
    },

    handleFeedbackSubmission(form) {
        if (!this.validateForm($(form))) {
            this.loadForm($(form), 'stop');
            return;
        }

        this.loadForm($(form), 'start');
        $.post(routes.postSend, {
            _token: $('meta[name="csrf-token"]').attr('content'),
            data: $(form).serialize(),
            subj: 'feedback',
            send_type: 'not_modal',
            form_id: 'none'
        }, () => {
            $(form)[0].reset();
            this.loadForm($(form), 'stop');
            if (gtmActive) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({ event: 'contact_form' });
            }
            if (is_facebook_pixel) fbq('track', 'contact_form');
            $(form).find('.form__success').removeClass('js_hide');
            $(form).find('.input__input').next('.input__placeholder').css({ top: '11px' }).end().removeClass('active_input');
            setTimeout(() => $(form).find('.form__success').addClass('js_hide'), 4000);
        });
    },

    handleLoginSubmission(form) {
        if (!this.validateForm($(form))) {
            this.loadForm($(form), 'stop');
            return;
        }

        this.loadForm($(form), 'start');
        $.post(routes.postLogin, {
            data: $(form).serialize(),
            lang
        }, (res) => {
            $('.input__error').hide();
            this.loadForm($(form), 'stop');
            if (res === 'wrong_pass') {
                $('#login_form .js_auth_error').slideDown(200);
            } else if (res === 'success') {
                window.location.reload(true);
            }
        });
    },

    handleRegisterSubmission(form) {
        if (!this.validateForm($(form))) {
            this.loadForm($(form), 'stop');
            return;
        }

        this.loadForm($(form), 'start');
        $.post(routes.postRegister, {
            data: $(form).serialize(),
            lang
        }, (res) => {
            $('.input__error').hide();
            this.loadForm($(form), 'stop');
            if (res === 'email') {
                $('#reg_form .js_auth_error').slideDown(200);
            } else if (res === 'deleted') {
                $('#reg_form .js_auth_del').slideDown(200);
            } else if (res === 'success') {
                $('#reg_form .js_reg_success').slideDown(200);
                if (gtmActive) {
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({ event: 'sign_up' });
                }
                setTimeout(() => window.location.reload(true), 3000);
            }
        });
    },

    handleResetSubmission(form) {
        if (!this.validateForm($(form))) {
            this.loadForm($(form), 'stop');
            return;
        }

        this.loadForm($(form), 'start');
        $.post(routes.postPassword, {
            data: $(form).serialize(),
            lang
        }, (res) => {
            $('.input__error').hide();
            this.loadForm($(form), 'stop');
            if (res === 'no_email') {
                $('#reset_form .js_auth_error').slideDown(200);
                $('#reset_form .js_auth_restored').slideUp(200);
            } else if (res === 'success') {
                $('#reset_form .js_auth_restored').slideDown(200);
                $('#reset_form .js_auth_error').slideUp(200);
                setTimeout(() => {
                    $('.modal.js_active').removeClass('js_active');
                    $('html').css('overflow', '');
                }, 3000);
            }
        });
    },

    submittingReviewAndFile(form, file) {
        this.handleReviewSubmission(form, file);
    },

    editWishIconGlobal() {
        this.updateWishIcon();
    }
};

window.submittingReviewAndFile = App.submittingReviewAndFile.bind(App);
window.editWishIconGlobal = App.editWishIconGlobal.bind(App);
window.isValidEmail = App.isValidEmail;

$(document).ready(() => {
    let recaptchaKey = null;

    $.get('/get-recaptcha-public-key', (res) => {
        if (res.status === 'ok' && res.public_key) {
            recaptchaKey = res.public_key;
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
            document.head.appendChild(script);
        }
    });

    if (mask_phone) {
        $('.input__input.phone').each((i, el) => {
            IMask(el, {
                mask: '+{38} ({\\0}00) 00 - 00 - 000',
            })
        })
    }

    $(document).on('click', '.js_good_id', (e) => App.handleProductButtonClick($(e.currentTarget)));
    $(document).on('click', '.js_btn_cart', (e) => App.handleAddToCart($(e.currentTarget)));
    $(document).on('click', '.js_amount_down', (e) => App.handleQuantityChange($(e.currentTarget), 'down'));
    $(document).on('click', '.js_amount_up', (e) => App.handleQuantityChange($(e.currentTarget), 'up'));
    $(document).on('click', '.js_good_delete', (e) => App.handleDeleteFromCart($(e.currentTarget)));
    $(document).on('click', '.js_get_variants', (e) => App.handleGetVariants($(e.currentTarget)));
    $(document).on('mouseover', '.good_tile__block', (e) => App.handleProductTileHover($(e.currentTarget)));
    $(document).on('click', '.js_btn_like', (e) => {
        e.stopPropagation();
        e.preventDefault();
        App.handleWishlistToggle($(e.currentTarget));
    });
    $(document).on('click', '.js_add_file', (e) => App.handleFileInput(e));
    $(document).on('click', '.js_item_file_delete', (e) => {
        const $item = $(e.currentTarget).parent('.js_item_file_reviews');
        $(`.input-file-js[name=${$item.attr('data-item')}]`).remove();
        $item.remove();
        if ($('.js_item_file_reviews').length < 2) $('.js_add_file').removeClass('js_hide');
    });
    $(document).on('click', '#reviews-btn', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $form = $('.review-form-js');
        const $inputs = $('.input-file-js');
        if (process.env.IS_RECAPTCHA === 'true' && recaptchaKey) {
            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaKey, { action: 'submit' }).then((token) => {
                    $form.append($('<input>').attr({ type: 'hidden', name: 'g-recaptcha-response', value: token }));
                    if ($inputs.length) {
                        const data = {};
                        $inputs.each((i, element) => {
                            if (element.files.length) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    data[`file_${i}`] = reader.result;
                                    if (i === $inputs.length - 1 || !$inputs[i + 1]?.files.length) {
                                        $.post(routes.postLoadFile, {
                                            _token: $('meta[name="csrf-token"]').attr('content'),
                                            data
                                        }, (res) => App.handleReviewSubmission($form[0], res.file_name));
                                    }
                                };
                                reader.readAsDataURL(element.files[0]);
                            }
                        });
                    } else {
                        App.handleReviewSubmission($form[0]);
                    }
                });
            });
        } else if ($inputs.length) {
            const data = {};
            $inputs.each((i, element) => {
                if (element.files.length) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        data[`file_${i}`] = reader.result;
                        if (i === $inputs.length - 1 || !$inputs[i + 1]?.files.length) {
                            $.post(routes.postLoadFile, {
                                _token: $('meta[name="csrf-token"]').attr('content'),
                                data
                            }, (res) => App.handleReviewSubmission($form[0], res.file_name));
                        }
                    };
                    reader.readAsDataURL(element.files[0]);
                }
            });
        } else {
            App.handleReviewSubmission($form[0]);
        }
    });
    $(document).on('change', '#checkbox_feedback', function () {
        const $feedback = $('#do_feedback');
        if (this.checked) {
            $feedback.removeClass('js_disabled');
            $('.js_text_error').addClass('js_hide');
            $('.js_text_yes').removeClass('js_hide');
        } else {
            $feedback.addClass('js_disabled');
            $('.js_text_yes').addClass('js_hide');
            $('.js_text_error').removeClass('js_hide');
        }
    });
    $(document).on('click', '#do_feedback', function () {
        if ($(this).hasClass('js_disabled')) {
            $('.js_text_yes').addClass('js_hide');
            $('.js_text_error').removeClass('js_hide');
        } else {
            App.handleFeedbackSubmission($('#feedback')[0]);
            $('.js_text_error').addClass('js_hide');
            $('.js_text_yes').removeClass('js_hide');
        }
    });
    $(document).on('click', '.js_form_btn', (e) => {
        e.preventDefault();
        if (process.env.IS_RECAPTCHA === 'true' && recaptchaKey) {
            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaKey, { action: 'submit' }).then((token) => {
                    const $form = $(`.js_form[id="${$(e.currentTarget).attr('data-id')}"]`);
                    $form.append($('<input>').attr({ type: 'hidden', name: 'g-recaptcha-response', value: token }));
                    App.handleFormSubmission($(e.currentTarget));
                });
            });
        } else {
            App.handleFormSubmission($(e.currentTarget));
        }
    });
    $(document).on('click', '.js_do_login_form', (e) => {
        e.preventDefault();
        e.stopPropagation();
        App.handleLoginSubmission($('#login_form')[0]);
    });
    $(document).on('click', '.js_do_reg_form', (e) => {
        e.preventDefault();
        e.stopPropagation();
        App.handleRegisterSubmission($('#reg_form')[0]);
    });
    $(document).on('click', '.js_do_reset_form', (e) => {
        e.preventDefault();
        e.stopPropagation();
        App.handleResetSubmission($('#reset_form')[0]);
    });
    $(document).on('click', '.js_password_view', function () {
        const $button = $(this);
        $button.toggleClass('view');
        const $input = $button.closest('.js_input_block').children('.view_false');
        $input.attr('type', $button.hasClass('view') ? 'text' : 'password');
        $button.find('.path_svg').toggle(!$button.hasClass('view'));
    });
    $(document).on('click', '.js_modal_btn', (e) => {
        const $button = $(e.currentTarget).closest('.js_modal_btn');
        if ($button.data('close')) $(`#${$button.data('close')}`).removeClass('js_active');
        if ($button.data('modal')) {
            $(`#${$button.data('modal')}`).addClass('js_active');
            $('html').css('overflow', 'hidden');
        }
    });
    $(document).on('click', '.js_modal_overlay', (e) => {
        const $modal = $(e.currentTarget).parent('.modal.js_active');
        if ($modal.length) {
            $modal.removeClass('js_active');
            $('html').css('overflow', '');
        }
    });
    $(document).on('click', '.js_modal_close', (e) => {
        const $modal = $(`#${$(e.currentTarget).data('close')}`);
        if ($modal.hasClass('js_active')) {
            $modal.removeClass('js_active');
            $('html').css('overflow', '');
        }
    });
    $(document).on('keydown', (e) => {
        const $modal = $('.modal.js_active');
        if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && $modal.length) {
            $modal.removeClass('js_active');
            $('html').css('overflow', '');
        }
    });

    $(document).on('blur', '.input__input.phone', function () {
        if (mask_phone) {
            const value = $(this).val().trim().replace(/\D/g, '')
            if (value.length < 12) {
                $(this).val('')
            }
        }
    })

    $('.js_form, #feedback, #login_form, #reg_form, #reset_form, .review-form-js').each(function () {
        $(this).append(`
            <input type="text" name="honeypot" style="display:none;" value="">
            <input type="hidden" name="timestamp" value="${Date.now()}">
        `);
    });

    $('.input__input[type="password"]').each(function () {
        $(this).addClass('view_false').after(`
            <button type="button" class="js_password_view password_view">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 6C8.41454 6 4.25621 8.63041 1.18779 12.9029C0.937404 13.2529 0.937404 13.7419 1.18779 14.092C4.25621 18.3696 8.41454 21 13 21C17.5855 21 21.7438 18.3696 24.8122 14.0971C25.0626 13.7471 25.0626 13.2581 24.8122 12.908C21.7438 8.63041 17.5855 6 13 6ZM13.1767 16.3415C11.537 16.4496 10.182 15.034 10.29 13.3147C10.3734 11.894 11.4732 10.7461 12.8282 10.6534C14.4679 10.5453 15.823 11.9609 15.7149 13.6802C15.6266 15.106 14.5268 16.2539 13.1767 16.3415Z" stroke="#333333" stroke-width="2"/>
                    <path class="path_svg" d="M25 1L1 25" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
        `);
    });
});